define.alias("ember-power-select/components/power-select-multiple", "media/components/power-select-multiple");